import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Button from 'react-bootstrap/Button';
import "./header.css";

export function Header() {
  return (
    <>
    <div className="sponsored-banner">
  Sponsored by <Button variant="dark" className="wonderchat-btn">Wonderchat</Button>
  <span className="sponsored-extra"> - <strong>AI Chatbot builder to create custom ChatGPT chatbots from website</strong></span>
</div>

  <header>
  <nav className="navbar navbar-expand-lg navbar-light custom-navbar">
    <div className="container d-flex justify-content-between align-items-center">
      
      {/* Logo - Always on the left */}
      <a className="navbar-brand" href="/">
        <img src="/images/logo.webp" alt="Logo" width="140" height="42" />
      </a>

      {/* Burger Icon - Only visible on small screens */}
      <button
        className="navbar-toggler d-lg-none"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Navigation Items */}
      <div className="collapse navbar-collapse animated-navbar" id="navbarContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Products
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href="#">Product 1</a></li>
              <li><a className="dropdown-item" href="#">Product 2</a></li>
            </ul>
          </li>

          <li className="nav-item"><a className="nav-link" href="#">Category</a></li>

          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Ranking
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href="#">Top</a></li>
              <li><a className="dropdown-item" href="#">Newest</a></li>
            </ul>
          </li>

          <li className="nav-item"><a className="nav-link" href="#">AI Models</a></li>
          <li className="nav-item"><a className="nav-link" href="#">Social Listening</a></li>

          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              Submit & Advertise
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href="#">Submit Tool</a></li>
              <li><a className="dropdown-item" href="#">Advertise</a></li>
            </ul>
          </li>

          <li className="nav-item">
            <a className="nav-link" href="#">
              AI SEO Tool <span className="badge bg-danger ms-1">New</span>
            </a>
          </li>
        </ul>

        <ul className="navbar-nav ms-auto mb-2 mb-lg-0 d-flex flex-row gap-3 align-items-center">
          <li className="nav-item">
            <a className="nav-link" href="/login">Login</a>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
              🌐 EN
            </a>
            <ul className="dropdown-menu dropdown-menu-end">
              <li><a className="dropdown-item" href="#">EN</a></li>
              <li><a className="dropdown-item" href="#">FR</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>


    </>
  );
}